"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaymentManual = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactBootstrap = require("react-bootstrap");
var _classnames = _interopRequireDefault(require("classnames"));
var _lodash = _interopRequireDefault(require("lodash"));
var _Icon = require("../Icon/Icon");
var _payment = require("../assets/icons/payment");
var _types = _interopRequireDefault(require("./types"));
var _PaymentManualModule = _interopRequireDefault(require("./PaymentManual.module.css"));
var _PaymentResult = require("../PaymentResult/PaymentResult");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var PaymentManual = function PaymentManual(_ref) {
  var platform = _ref.platform,
    actionType = _ref.actionType,
    type = _ref.type,
    logo = _ref.logo,
    minAmount = _ref.minAmount,
    cardOptions = _ref.cardOptions,
    header = _ref.header,
    content = _ref.content,
    callback = _ref.callback,
    resendHandler = _ref.resendHandler,
    eventKey = _ref.eventKey,
    className = _ref.className,
    style = _ref.style;
  var _useState = (0, _react.useState)({}),
    _useState2 = _slicedToArray(_useState, 2),
    data = _useState2[0],
    setData = _useState2[1];
  var _useState3 = (0, _react.useState)({}),
    _useState4 = _slicedToArray(_useState3, 2),
    error = _useState4[0],
    setError = _useState4[1];
  var _useState5 = (0, _react.useState)({
      show: false,
      timeout: null
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    sms = _useState6[0],
    setSms = _useState6[1];
  (0, _react.useEffect)(function () {
    if (!_lodash.default.isEmpty(data)) {
      //console.log(data);

      //validate data
      var updatedError = {};
      if (type === 'card' && (data === null || data === void 0 ? void 0 : data.cardId.trim()) === '') updatedError.cardId = 'ბარათი არასწორად არის მითითებული';
      if (type === 'wallet' && actionType === 'withdraw' && (data === null || data === void 0 ? void 0 : data.iban.trim()) === '') updatedError.iban = 'ანგარიშის ნომერი არასწორად არის მითითებული';
      if (isNaN(parseFloat(data === null || data === void 0 ? void 0 : data.amount))) updatedError.amount = 'თანხა არასწორად არის მითითებული';
      if (sms.show && (data === null || data === void 0 ? void 0 : data.sms.trim()) === '') updatedError.sms = 'სმს კოდი არასწორია';
      setError(updatedError);

      //if validated:
      if (_lodash.default.isEmpty(updatedError)) {
        var _callback = callback(data),
          err = _callback.error,
          timeout = _callback.timeout,
          status = _callback.status;
        if (err) {
          setError(err);
        } else if (!data.sms) {
          setSms({
            show: true,
            timeout: timeout
          });
        }
      }
    }
  }, [data]);
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Accordion.Item, _extends({
    className: (0, _classnames.default)(_PaymentManualModule.default.container, _PaymentManualModule.default[platform], className),
    style: _objectSpread(_objectSpread({}, style), {}, {
      flexDirection: platform === 'web' && type !== 'info' ? 'row' : 'column'
    })
  }, platform === 'mob' || type === 'info' ? {
    eventKey: eventKey
  } : {}), /*#__PURE__*/_react.default.createElement(platform === 'web' && type !== 'info' ? 'div' : _reactBootstrap.Accordion.Header, _objectSpread({
    className: _PaymentManualModule.default.header,
    as: 'div',
    style: {
      width: platform === 'web' && (type === 'card' || sms.show || actionType === 'withdraw') ? '40%' : '100%'
    }
  }, platform === 'mob' && {
    onClick: function onClick() {
      return setError({});
    }
  }), /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_PaymentManualModule.default.logo, eventKey === 'Any' && _PaymentManualModule.default.any),
    style: {
      backgroundImage: "url(".concat(logo, ")")
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _PaymentManualModule.default.right,
    style: {
      flex: type === 'info' ? 1 : 'none'
      /*...(type === 'info' && { marginRight: '20%' }),*/
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _PaymentManualModule.default.info
  }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    Icon: _payment.Info,
    type: 'vec',
    height: '100%',
    width: '100%',
    style: {
      maskSize: '90%',
      WebkitMaskSize: '90%',
      backgroundColor: _lodash.default.isEmpty(error) ? '#5C74A5' : 'var(--bs-danger)'
    },
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }), /*#__PURE__*/_react.default.createElement("p", {
    className: _PaymentManualModule.default.message
  }, "\u10DB\u10D8\u10DC.\u10D7\u10D0\u10DC\u10EE\u10D0 ", minAmount, " \u10DA\u10D0\u10E0\u10D8 \u10E1\u10D0\u10D9\u10DD\u10DB\u10D8\u10E1\u10D8\u10DD 0%")), type === 'info' && /*#__PURE__*/_react.default.createElement("div", {
    className: _PaymentManualModule.default.details
  }, header, platform === 'web' && /*#__PURE__*/_react.default.createElement("span", {
    className: _PaymentManualModule.default.label
  }, "\u10D8\u10DC\u10E1\u10E2\u10E0\u10E3\u10E5\u10EA\u10D8\u10D0"))))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Accordion.Body, {
    className: _PaymentManualModule.default.body,
    style: type === 'info' ? {
      borderTop: '1px solid #DEDEDE'
    } : {}
  }, /*#__PURE__*/_react.default.createElement(sms.show ? _types.default['sms'] : _types.default[type], _objectSpread(_objectSpread({
    platform: platform,
    actionType: actionType,
    cardOptions: cardOptions,
    error: error,
    content: content
  }, sms.show && {
    timeout: sms.timeout,
    resendHandler: resendHandler
  }), {}, {
    callback: function callback(updatedData) {
      return setData(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), updatedData);
      });
    }
  }))));
};
exports.PaymentManual = PaymentManual;
PaymentManual.propTypes = {
  platform: _propTypes.default.oneOf(['web', 'mob']),
  actionType: _propTypes.default.oneOf(['deposit', 'withdraw']),
  type: _propTypes.default.oneOf(['card', 'wallet', 'info']),
  logo: _propTypes.default.string,
  minAmount: _propTypes.default.number,
  cardOptions: _propTypes.default.array,
  callback: _propTypes.default.func
};
PaymentManual.defaultProps = {
  platform: 'mob',
  actionType: 'deposit',
  type: 'card',
  logo: _payment.Bog,
  minAmount: 1,
  cardOptions: []
};